import React from 'react'
import { message } from 'antd'
import { useHistory } from 'react-router-dom'
import { useAsync } from 'react-use'
import { useLocalization } from '@contexts/LocalizationContext'
import PageLayout from '@layouts/PageLayout'
import FormComponent from './Form'
import { client } from '@utils/client'

const Create = () => {
  const history = useHistory()
  const { t } = useLocalization()

  const state = useAsync(async () => {
    const specialties = await client.get('/specialist').then((res) => res.data)
    const result = specialties.data.map((item) => ({
      label: item.name,
      value: item.id,
    }))
    return result
  }, [])

  const handleSubmit = async (data) => {
    try {
      data.specialistIds = []
      await client.post('/hospital', data)
      message.success('สำเร็จ')
      history.push('/hospitals')
    } catch (e) {
      message.error('ไม่สำเร็จ')
    }
  }

  if (state.loading) {
    return null
  }

  return (
    <PageLayout title={t('hospital.createScreen.title')} extra={[]}>
      <FormComponent specialties={state.value} handleSubmit={handleSubmit} />
    </PageLayout>
  )
}

export default Create
